export default {
  lscsPath: 'https://api-cms-sit.hktdc.com/ls/v2',
  projectNamePath: '%2F%2Fcmsapp%2F',
  apiContext: '',
  subDirectoryPath: '',
  routePathTo: `/${process.env.REACT_APP_TSPROJECTNAME}`,
  locationServiceEndPoint: 'https://api-general-uat.hktdc.com/location/v1/location-service',
  footer_js_env: '-sit',
  autoCompletePath: 'https://api-fair-uat.hktdc.com/fair-core/v1/auto-complete',
  eventPath: 'https://event-uat.hktdc.com',
  researchDomain: 'https://research-sit.hktdc.com',
  sbeProgramePath: 'https://api-cms-sit.hktdc.com/sbe/v1/seminar/programme',
  sbeSpeakerPath: 'https://api-cms-sit.hktdc.com/sbe/v1/seminar/speakers',
  epcPath: 'https://home-uat.hktdc.com/epc/webservice/subscription',
  epcAppId: 18,
  googleCaptchaAction: 'subscription',
  googleCaptchaPath: 'https://api-general-uat.hktdc.com/captcha/v1/recaptcha/verify',
  googleSitekey: `${process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY1}${process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY2}${process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY3}`,
  tencentCaptchaPath: 'https://api-general-uat.hktdc.com/captcha/v1/tencent/verify',
  tencentCaptchaAppId: `${process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID1}${process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID2}${process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID3}`,
  captchaLocationPath: 'https://api-cms-uat.hktdc.com/captcha/location',
  xApiKey: `${process.env.REACT_APP_CAPTURA_API_KEY1}${process.env.REACT_APP_CAPTURA_API_KEY2}${process.env.REACT_APP_CAPTURA_API_KEY3}`,
};
